// removed by extract-text-webpack-plugin
module.exports = {"versionBlock":"uLJYYD1uRju86zuI_lKsL","versionDescription":"_1izo8SmygxLVA5JDsZmaPM","versionName":"MMkjvzE5TSifG7qPci057","songEdit":"_1-SQgJ85tVt2ps0IMW2dNq","editForm":"i7g4Rl2gqCkGzhMU3B_OY","readonly":"_1bLR6nA9G8OWhSzybD3aFE","songMetaInfos":"_13rM9KHxe7qtOlFFbaTTn_","songMetaInfo":"_1c7OqHWt_rnzOf-VZezfR5","videos":"_2b8VHLLwWOwOilJmSbBN77","persons":"cScJFOsuXH_K1knuJL5Oo","personsEdit":"_2ye5_x2jmelq0kWLS1fRJq","songTextRoot":"_2vLvLC0re76ZoZD7FZ06fB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Song/Song.scss
// module id = 262
// module chunks = 0